import { useMemo } from "react";
import { VideoRenderingState } from "./types";
import { UpdateRelatedAssetMetadataDtoAccessibilityPurposeEnum } from "generated";
import { useStore } from "@/services/store";

/**
 * Hook that computes rendering state based on the flowchart logic
 */
export function useVideoMetadataFields(assetId: number): VideoRenderingState {
  const asset = useStore((state) => state.videoAssets[assetId]);

  return useMemo(() => {
    if (asset?.isOnlySocialMedia === true) {
      return {
        shouldShowOptionalFiles: true,
        canAddSubtitles: true,
        canAddTranscript: true,
        canAddAudioDescription: true,
        canAddCaption: true,
      };
    }

    if (
      asset?.accessibilityPurpose ===
      UpdateRelatedAssetMetadataDtoAccessibilityPurposeEnum.Decorative
    ) {
      return {
        shouldShowOptionalFiles: true,
        canAddAudioDescription: true,
        canAddCaption: true,
        canAddSubtitles: true,
        canAddTranscript: true,
      };
    }

    if (
      asset?.accessibilityPurpose ===
      UpdateRelatedAssetMetadataDtoAccessibilityPurposeEnum.Informative
    ) {
      return {
        shouldShowOptionalFiles: true,
        canAddSubtitles: true,
        canAddCaption: !asset.isVideoWithAudio,
        shouldShowRequiredFiles: true,
        requiresTranscript: true,
        requiresAudioDescription: true,
        requiresCaption: asset.isVideoWithAudio,
      };
    }

    // Nothing selected or No answer for "Does the video contain audio?"
    return {};
  }, [asset]);
}
